//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { options } from '@/assets/js/city'
  import {
    getEducation,
    getIndustry,
    getConsumerType,
    getProviderType,
    getCredit,
    getCreditIndustry,
    getJobTitle,
  } from '@/assets/js/dict';
export default {
    created(){
        this.options = options;
        getEducation().then(res => {
            this.educations = res;
        })
        getIndustry().then(res => {
            this.industrys = res;
        })
        getConsumerType().then(res => {
            this.consumers = res;
        })
        getProviderType().then(res => {
            this.providers = res;
        })
        getCredit().then(res => {
            this.credits = res;
        })
        getCreditIndustry().then(res => {
            this.creditIndustrys = res;
        })
        getJobTitle().then(res => {
            this.jobTitles = res;
        })
    },
    data(){
        return{
            pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
        },
        props: {
          multiple: true
        },
        size:'normal',
        headers: {},
        consumers: [],
        providers: [],
        industry:[],
        industrys: [],
        jobTitles: [],
        serviceList: [],
        credits: [],
        creditIndustrys: [],
        educations: [],
        dialogVisible: false,
        isgetverifycode: false, //手机号验证
        isIDnumber: false, //身份证号
        info:'',
        userPersonalExpertParam: { //个人信息
          realName: '',
          intro: '',
          jobTitle: '',
          idNumber: '',
          qualificationName: '',
          contactNumber: '',
          contactAddressCode: '',
          contactAddressDetail: ''
        },
        userEnterprise: { //企业信息
          principalName: '',
          principalMobile: '',
          staffAmount: '',
          realName: '',
          regTime: '',
          regFund: '',
          intro: '',
          businessScope: '',
          contactAddressCode: '',
          contactAddressDetail: ''
        },
        userIndustryList: [],
        userIndustryLists: [],
        userConsultCreditList: [],
        userAchievementList: [],
        personList:[
          {
            fileUrl: '',
            fileName: '',
            authFileType: 'pcardz',
            settledType: '1',
            userType: '2'
          },
           {
            fileUrl: '',
            fileName: '',
            authFileType: 'pcardf',
            settledType: '1',
            userType: '2'
          }
        ],
        firmList: [{
            fileUrl: '',
            fileName: '',
            authFileType: 'zhizhao',
            settledType: '3',
            userType: '2'
          }
        ],
        srcList:[],
        rules: {
          realName: {
            required: true,
            message: '请填写姓名',
            trigger: 'blur'
          },
          realNames: {
            required: true,
            message: '请填写企业名称',
            trigger: 'blur'
          },
          realNamew: {
            required: true,
            message: '请填写工作室名称',
            trigger: 'blur'
          },
          idNumber: [{
              required: true,
              validator: this.numberValid,
              trigger: 'blur',
            },
            {
              max: 18,
              message: '长度为最多为18位',
              trigger: 'blur'
            }
          ],
          contactNumber: [{
              required: true,
              validator: this.mobileValid,
              trigger: 'blur'
            },
            {
              max: 11,
              message: '长度为11位',
              trigger: 'blur'
            }
          ],
          contactAddressCode: {
            required: true,
            message: '请选择省市区',
            trigger: 'change'
          },
          contactAddressDetail: {
            required: true,
            message: '请填写详细地址',
            trigger: 'blur'
          },
          regTime: {
            required: true,
            message: '请选择日期',
            trigger: 'change'
          },
          regFund: {
            required: true,
            message: '请填写注册资金',
            trigger: 'blur'
          },
          businessScope: {
            required: true,
            message: '请填写经营范围',
            trigger: 'blur'
          },
          intro: {
            required: true,
            message: '请填写简介',
            trigger: 'blur'
          },
          jobTitle: {
            required: true,
            message: '请选择技术职称',
            trigger: 'change'
          },
          staffAmount: {
            required: true,
            message: '请填写工作室人数',
            trigger: 'blur'
          },
          principalName: {
            required: true,
            message: '请填写负责人姓名',
            trigger: 'blur'
          },
          principalMobile: [
            {
                required: true,
                validator: this.mobileValid,
                trigger: 'blur'
              },
              {
                max: 11,
                message: '长度为11位',
                trigger: 'blur'
              }
          ]
        }
        }
    },
    methods: {
        // 手机号码校验
      mobileValid(rule, value, callback) {
        if (!(/^1[3456789]\d{9}$/.test(value))) {
          callback(new Error('请输入正确手机号码'));
          this.isgetverifycode = false;
        } else {
          this.isgetverifycode = true;
          callback();
        }
      },
      numberValid(rule, val, callback) {
        var checkCode = function(val) {
          var p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, ];
          var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
          var code='';
          if(val){
             code= val.substring(17);
          }
          if (p.test(val)) {
            var sum = 0;
            for (var i = 0; i < 17; i++) {
              sum += val[i] * factor[i];
            }
            if (parity[sum % 11] == code.toUpperCase()) {
              return true;
            }
          }
          return false;
        };
        var checkDate = function(val) {
          var pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
          if (pattern.test(val)) {
            var year = val.substring(0, 4);
            var month = val.substring(4, 6);
            var date = val.substring(6, 8);
            var date2 = new Date(year + "-" + month + "-" + date);
            if (date2 && date2.getMonth() == parseInt(month) - 1) {
              return true;
            }
          }
          return false;
        };
        var checkProv = function(val) {
          var pattern = /^[1-9][0-9]/;
          var provs = {
            11: "北京",
            12: "天津",
            13: "河北",
            14: "山西",
            15: "内蒙古",
            21: "辽宁",
            22: "吉林",
            23: "黑龙江 ",
            31: "上海",
            32: "江苏",
            33: "浙江",
            34: "安徽",
            35: "福建",
            36: "江西",
            37: "山东",
            41: "河南",
            42: "湖北 ",
            43: "湖南",
            44: "广东",
            45: "广西",
            46: "海南",
            50: "重庆",
            51: "四川",
            52: "贵州",
            53: "云南",
            54: "西藏 ",
            61: "陕西",
            62: "甘肃",
            63: "青海",
            64: "宁夏",
            65: "新疆",
            71: "台湾",
            81: "香港",
            82: "澳门",
          };
          if (pattern.test(val)) {
            if (provs[val]) {
              return true;
            }
          }
          return false;
        };
        if (checkCode(val)) {
          var date = val.substring(6, 14);
          if (checkDate(date)) {
            if (checkProv(val.substring(0, 2))) {
              callback();
            }
          }
        } else {
          callback(new Error("请输入正确的身份证号码"));
          return false;
        }
      },
        // 获取个人信息
        getInfo(){
            this.$get('/sys/user/info','',function(res){
                this.info = res.data;
                if (res.data.currentUserType == 2) {
                this.info.consumerType = this.$route.query.type;
                var userAuthFileList = res.data.userAuthFileList;
                var userIndustryList= res.data.userIndustryList;
                var industry=[];
                for (let i = 0; i < userIndustryList.length; i++) {
                    industry.push(userIndustryList[i].industry);
                }
                this.industry= industry
                this.userIndustryList = userIndustryList
                if(res.data.consumerType==1){ //个人
                    if (res.data.userAuthFileList.length != 0) {
                        for (var i = 0; i < userAuthFileList.length; i++) {
                            for (var j = 0; j < this.personList.length; j++) {
                                if (userAuthFileList[i].authFileType == this.personList[j].authFileType) {
                                    this.personList[j] = userAuthFileList[i];
                                }
                            }
                        }
                    }
                }
                if(res.data.consumerType==3){ //企业
                    if (res.data.userAuthFileList.length != 0) {
                    for (var i = 0; i < userAuthFileList.length; i++) {
                        for (var j = 0; j < this.firmList.length; j++) {
                        if (userAuthFileList[i].authFileType == this.firmList[j].authFileType) {
                            this.firmList[j] = userAuthFileList[i];
                        }
                        }
                    }
                    }
                }
                }
                if (res.data.userPersonalExpertParam) { //个人信息
                    this.userPersonalExpertParam = res.data.userPersonalExpertParam;
                    if(res.data.userPersonalExpertParam.contactAddressCode){
                        this.userPersonalExpertParam.contactAddressCode = res.data.userPersonalExpertParam.contactAddressCode.split(',');
                        if(this.userPersonalExpertParam.contactAddressCode.length==3){
                            this.userPersonalExpertParam.contactAddressCode.splice(2,1)
                        }
                    }
                }
                if (res.data.userEnterprise) {
                    this.userEnterprise = res.data.userEnterprise; //企业信息
                    if(res.data.userEnterprise.contactAddressCode){
                        this.userEnterprise.contactAddressCode = res.data.userEnterprise.contactAddressCode.split(',');
                        if(this.userEnterprise.contactAddressCode.length==3){
                            this.userEnterprise.contactAddressCode.splice(2,1)
                        }
                    }
                }
            })
        },

        // 切换行业
        changeIndustry(val){
            var industrylist=[];
            for (let i = 0; i < val.length; i++) {
                var obj={};
                obj.industry =val[i];
                obj.userType = this.info.currentUserType;
                obj.settledType = this.info.consumerType;
                industrylist.push(obj);
            }
            this.userIndustryList = industrylist;
        },

        // 上传扫描件
        handleAvatarSuccessT(index, res, file) {
            if (this.info.consumerType == 1) {
            this.personList[index].uploadImg = URL.createObjectURL(file.raw);
            this.personList[index].fileName = res.data.fileName;
            this.personList[index].fileUrl = res.data.fileUrl;
            this.personList[index].settledType = this.info.consumerType;
            }
            if (this.info.consumerType == 3) {
            this.firmList[index].uploadImg = URL.createObjectURL(file.raw);
            this.firmList[index].fileName = res.data.fileName;
            this.firmList[index].fileUrl = res.data.fileUrl;
            this.firmList[index].settledType = this.info.consumerType;
            }
        },
        beforeAvatarUploadT(file) {
            const isJPG = file.type.split('/')[0] === 'image';
            const isLt1G = file.size / 1024 / 1024  < 10;
            if (!isLt1G) {
            this.$message.error('文件大小超过 10MB!');
            }
            if(!isJPG){
            this.$message.error('只能上传图片格式!');
            }
            return isJPG&&isLt1G;
        },

        // 删除扫描件
        removeImg(index){
            if(this.info.consumerType == 1){
            this.personList[index].fileUrl=''
            }
            if(this.info.consumerType == 3){
            this.firmList[index].fileUrl=''
            }
        },

        // 提交数据
        save(info) {
            // 个人类型传值
            if (this.info.consumerType == 1 && this.info.currentUserType == 2) {
                this.$refs[info].validate((valid) => {
                    if (!valid) {
                        this.$message.info('有必填项未填写')
                         document.documentElement.scrollTop = 60
                        return
                    }
                    if (valid) {
                        this.userPersonalExpertParam.contactAddressCode = this.userPersonalExpertParam.contactAddressCode.toString();
                        this.userPersonalExpertParam.contactAddressDetail = ''
                        for (var i = 0; i < this.personList.length; i++) {
                            if (this.personList[i].authFileType == 'pcardz') {
                                if (this.personList[i].fileUrl == '') {
                                    this.$message.error('请上传身份证正面');
                                    return;
                                }
                            }
                            if (this.personList[i].authFileType == 'pcardf') {
                                if (this.personList[i].fileUrl == '') {
                                    this.$message.error('请上传身份证反面');
                                    return;
                                }
                            }
                        }
                        this.$post('/sys/user/auth', {
                            currentUserType: '2',
                            consumerType: this.info.consumerType,
                            userPersonalExpertParam: this.userPersonalExpertParam,
                            userAuthFileList: this.personList,
                            userIndustryList: this.userIndustryList,
                            id: this.info.id,
                        }, function (res) {
                            if (res.code == 200) {
                                this.$message.success('提交成功!');
                                setTimeout(() => {
                                    this.$router.replace('/person/index')
                                }, 2000);
                            } else {
                                this.$message.error(res.msg)
                            }
                        }, true)
                    }
                })

            }
            // 企业类型传值
            if (this.info.consumerType == 3 && this.info.currentUserType == 2) {
                this.$refs[info].validate((valid) => {
                    if (!valid) {
                        this.$message.info('有必填项未填写')
                         document.documentElement.scrollTop = 60
                        return
                    }
                    if (valid) {
                        this.userEnterprise.contactAddressCode = this.userEnterprise.contactAddressCode.toString();
                        this.userEnterprise.contactAddressDetail = ''
                        for (var i = 0; i < this.firmList.length; i++) {
                            if (this.firmList[i].authFileType == 'zhizhao') {
                                if (this.firmList[i].fileUrl == '') {
                                    this.$message.error('请上传营业执照');
                                    return;
                                }
                            }
                        }
                        var data = {
                            currentUserType: '2',
                            consumerType: this.info.consumerType,
                            userEnterprise: this.userEnterprise,
                            userAuthFileList: this.firmList,
                            userIndustryList: this.userIndustryList,
                            id: this.info.id,
                        }
                        this.$post('/sys/user/auth', data, function (res) {
                            if (res.code == 200) {
                                this.$message.success('提交成功!');
                                setTimeout(() => {
                                    this.$router.replace('/person/index')
                                }, 2000);
                            } else {
                                this.$message.error(res.msg)
                            }
                        }, true)
                    }
                })

            }
        }
       
    },
    mounted() {
        this.headers = {
            "Authorization": 'bearer ' + getSession('token').access_token
        }
       this.getInfo()
    }
}
